import React from 'react'
import HistorialModeSelector from './HistorialModeSelector'
import HistorialReviewShell from './HistorialReviewShell'
import ProcesamientoInfoPanel from './ProcesamientoInfoPanel'
import ProcesamientoClinicalPanels from './ProcesamientoClinicalPanels'
import EdicionToolbar from './EdicionToolbar'
import YearlyLaborTable from './YearlyLaborTable'
import MutationAuditAccordion from './MutationAuditAccordion'
import Step4Footer from './Step4Footer'
import useSmartDefaults from '../hooks/useSmartDefaults'

/**
 * Step4Panel — Extracted from App.jsx inline Paso 4 block.
 *
 * Renders all sub-components for the historical labor data review step.
 * Derives asistidoMode from modoHerramienta and passes it down.
 * Calls useSmartDefaults at the top level to apply assisted-mode defaults.
 *
 * Props:
 *   { step4Props, modoHerramienta, rows, reviewTab }
 */
export default function Step4Panel({ step4Props, modoHerramienta, rows, reviewTab }) {
  const asistidoMode = modoHerramienta === 'base'

  useSmartDefaults(
    rows,
    asistidoMode,
    step4Props.yearlyTableProps.updateRowField,
    step4Props.footerProps.rows?.[0]?.periodo,
  )

  return (
    <>
      <HistorialModeSelector
        asistidoMode={asistidoMode}
        {...step4Props.modeSelectorProps}
      />

      {rows.length > 0 && (
        <>
          <HistorialReviewShell {...step4Props.reviewShellProps} />

          {reviewTab === 'procesamiento' && (
            <>
              <ProcesamientoInfoPanel
                asistidoMode={asistidoMode}
                {...step4Props.procesamientoInfoProps}
              />
              <ProcesamientoClinicalPanels
                asistidoMode={asistidoMode}
                {...step4Props.clinicalPanelsProps}
              />
            </>
          )}

          {reviewTab === 'edicion' && (
            <>
              <EdicionToolbar
                asistidoMode={asistidoMode}
                {...step4Props.edicionToolbarProps}
              />
              <YearlyLaborTable
                asistidoMode={asistidoMode}
                {...step4Props.yearlyTableProps}
              />
              <MutationAuditAccordion
                asistidoMode={asistidoMode}
                {...step4Props.mutationAccordionProps}
              />
            </>
          )}

          <Step4Footer
            asistidoMode={asistidoMode}
            {...step4Props.footerProps}
          />
        </>
      )}
    </>
  )
}
